import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=45b3d82a&scoped=true"
import script from "./DetailDrawer.vue?vue&type=script&lang=js"
export * from "./DetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=45b3d82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3d82a",
  null
  
)

export default component.exports